import { MessageCircle } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useApp } from "@/context/AppContext";

export const Products = () => {
  const { content, products, t, wa, lang } = useApp();
  const sec = content.products_section;

  return (
    <section id="komoditas" data-testid="products-section" className="px-4 sm:px-8 lg:px-16 py-20 sm:py-28 bg-[#F2ECE1]">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
        <div>
          <Reveal>
            <p className="text-xs font-mono uppercase tracking-[0.25em] text-[#D96B27] font-semibold">03 // {t(sec.heading)}</p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 font-serif font-bold text-3xl sm:text-4xl lg:text-5xl text-[#1E3A2B] tracking-tight leading-[1.12]" data-testid="products-heading">
              {t(sec.heading)}
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="lg:max-w-md">
          <p className="text-base text-[#5C6B61] leading-relaxed">{t(sec.intro)}</p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
        {products.map((p, i) => (
          <Reveal key={p.id} delay={0.06 * (i % 3)} className={i === 0 ? "md:col-span-2 lg:col-span-1" : ""}>
            <article
              className="group h-full rounded-2xl border border-[#1E3A2B]/10 bg-[#FAF7F2] overflow-hidden hover:shadow-2xl hover:shadow-[#1E3A2B]/10 transition-shadow duration-500"
              data-testid={`product-card-${i}`}
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img
                  src={p.image}
                  alt={t(p.name)}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#14281E]/45 via-transparent to-transparent opacity-70" />
                <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-[#FAF7F2]/90 backdrop-blur text-[10px] font-mono uppercase tracking-[0.18em] font-semibold text-[#1E3A2B]">
                  {t(p.tag)}
                </span>
                <span className="absolute bottom-4 right-4 font-mono text-xs text-[#FAF7F2]/80">0{i + 1}</span>
              </div>
              <div className="p-6 sm:p-7">
                <h3 className="font-serif text-2xl font-semibold text-[#1E3A2B] transition-colors duration-300 group-hover:text-[#D96B27]" data-testid={`product-name-${i}`}>
                  {t(p.name)}
                </h3>
                <p className="mt-2.5 text-sm text-[#5C6B61] leading-relaxed">{t(p.desc)}</p>
                <div className="mt-5 flex items-center justify-between gap-3">
                  <p className="font-mono text-sm font-semibold text-[#1E3A2B]" data-testid={`product-price-${i}`}>
                    {p.price} <span className="text-[#5C6B61] font-normal">{t(p.unit)}</span>
                  </p>
                  <a
                    data-testid={`product-order-button-${i}`}
                    href={wa(
                      lang === "id"
                        ? `Halo Yutaka Agro, saya ingin memesan ${t(p.name)} (${p.price}${t(p.unit)}). Mohon info ketersediaan.`
                        : `Hello Yutaka Agro, I would like to order ${t(p.name)} (${p.price}${t(p.unit)}). Please share availability.`
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 px-4 py-2 rounded-full bg-[#1E3A2B] text-[#FAF7F2] text-xs font-semibold hover:bg-[#D96B27] transition-colors duration-300"
                  >
                    <MessageCircle size={13} />
                    {lang === "id" ? "Pesan" : "Order"}
                  </a>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
